import { render, staticRenderFns } from "./DivisaoTabela.vue?vue&type=template&id=4e67ef70&scoped=true&lang=html"
import script from "./DivisaoTabela.vue?vue&type=script&lang=js"
export * from "./DivisaoTabela.vue?vue&type=script&lang=js"
import style0 from "./DivisaoTabela.vue?vue&type=style&index=0&id=4e67ef70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67ef70",
  null
  
)

export default component.exports